import { render, staticRenderFns } from "./MaterialReport.vue?vue&type=template&id=1389b0f0"
import script from "./MaterialReport.vue?vue&type=script&lang=js"
export * from "./MaterialReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports